import React, { useState, useEffect } from 'react';
import axios from 'axios';

//const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';
const API = 'http://localhost:5000/api';
const ProductionTab = () => {
  const [batches, setBatches]         = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [products, setProducts]       = useState([]);
  const [loading, setLoading]         = useState(true);
  const [showForm, setShowForm]       = useState(false);
  const [formData, setFormData]       = useState({
    raw_material_id: '', product_id: '', meters_used: '',
    rolls_produced: '', wastage_meters: '', production_date: '', notes: ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchAll = async () => {
    try {
      const [batchRes, rawRes, invRes] = await Promise.all([
        axios.get(`${API}/tape/production`, { headers }),
        axios.get(`${API}/tape/raw-materials`, { headers }),
        axios.get(`${API}/tape/inventory`, { headers }),
      ]);
      setBatches(batchRes.data.data || []);
      setRawMaterials(rawRes.data.data || []);
      // We get product list from inventory since it has product names
      setProducts(invRes.data.data || []);
    } catch {
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  const handleSave = async () => {
    if (!formData.raw_material_id || !formData.product_id || !formData.meters_used || !formData.rolls_produced || !formData.production_date) {
      setError('All required fields must be filled');
      return;
    }
    setSaving(true);
    try {
      await axios.post(`${API}/tape/production`, formData, { headers });
      setShowForm(false);
      setFormData({ raw_material_id: '', product_id: '', meters_used: '', rolls_produced: '', wastage_meters: '', production_date: '', notes: '' });
      fetchAll();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save production batch');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this production batch?')) return;
    try {
      await axios.delete(`${API}/tape/production/${id}`, { headers });
      fetchAll();
    } catch {
      setError('Failed to delete');
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', color: '#7f8c8d' }}>Loading...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', margin: 0 }}>⚙️ Production</h2>
        <button
          onClick={() => { setShowForm(true); setError(''); }}
          style={{ padding: '12px 24px', background: '#f39c12', border: 'none', borderRadius: '10px', color: 'white', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
        >
          + Add Production Batch
        </button>
      </div>

      {error && (
        <div style={{ background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#e74c3c' }}>
          {error}
        </div>
      )}

      {showForm && (
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', marginBottom: '24px', border: '2px solid #f39c12' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50', marginBottom: '20px' }}>New Production Batch</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Raw Material (Big Roll) *</label>
              <select
                value={formData.raw_material_id}
                onChange={e => setFormData({ ...formData, raw_material_id: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              >
                <option value="">Select Roll</option>
                {rawMaterials.map(r => (
                  <option key={r.id} value={r.id}>{r.roll_number} ({r.remaining_meters}m remaining)</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Product *</label>
              <select
                value={formData.product_id}
                onChange={e => setFormData({ ...formData, product_id: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              >
                <option value="">Select Product</option>
                {products.map(p => (
                  <option key={p.product_id} value={p.product_id}>{p.product_name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Meters Used *</label>
              <input
                type="number"
                value={formData.meters_used}
                onChange={e => setFormData({ ...formData, meters_used: e.target.value })}
                placeholder="e.g. 500"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Rolls Produced *</label>
              <input
                type="number"
                value={formData.rolls_produced}
                onChange={e => setFormData({ ...formData, rolls_produced: e.target.value })}
                placeholder="e.g. 25"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Wastage Meters</label>
              <input
                type="number"
                value={formData.wastage_meters}
                onChange={e => setFormData({ ...formData, wastage_meters: e.target.value })}
                placeholder="e.g. 5"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Production Date *</label>
              <input
                type="date"
                value={formData.production_date}
                onChange={e => setFormData({ ...formData, production_date: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Notes</label>
              <input
                type="text"
                value={formData.notes}
                onChange={e => setFormData({ ...formData, notes: e.target.value })}
                placeholder="Optional notes"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button onClick={handleSave} disabled={saving} style={{ padding: '10px 24px', background: '#f39c12', border: 'none', borderRadius: '8px', color: 'white', cursor: 'pointer', fontWeight: '600' }}>
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button onClick={() => setShowForm(false)} style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: '8px', color: '#555', cursor: 'pointer', fontWeight: '600' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['#', 'Roll Used', 'Product', 'Meters Used', 'Rolls Produced', 'Wastage', 'Date', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', color: '#7f8c8d', fontWeight: '600' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {batches.map((batch, index) => (
                <tr key={batch.id} style={{ borderBottom: '1px solid #f0f0f0', background: index % 2 === 0 ? 'white' : '#fafafa' }}>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{index + 1}</td>
                  <td style={{ padding: '12px 16px', fontWeight: '600', color: '#2c3e50' }}>{batch.raw_material_roll_number}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{batch.product_name}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{batch.meters_used}m</td>
                  <td style={{ padding: '12px 16px', fontWeight: '700', color: '#27ae60' }}>{batch.rolls_produced} rolls</td>
                  <td style={{ padding: '12px 16px', color: '#e74c3c' }}>{batch.wastage_meters}m</td>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{new Date(batch.production_date).toLocaleDateString()}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <button
                      onClick={() => handleDelete(batch.id)}
                      style={{ padding: '6px 14px', background: '#e74c3c', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {batches.length === 0 && (
                <tr>
                  <td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: '#7f8c8d' }}>No production batches yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductionTab;